module.exports = __webpack_public_path__ + "static/media/dhruvi_dlDHU96UwE.cef50141.jpg";